import styled from "styled-components";
import { Button, Form } from "antd";
import { theme } from "../../../config";

export const FormItem = styled(Form.Item)`
  height: 85px;
  width: 100%;

  ${theme.formErrorMobileView}

  @media ${theme.breakpoints.mobileAndTablet} {
    height: 70px;
  }
`;

export const ResetPasswordButton = styled(Button)`
  padding: 15px 0;
`;

export const AccountStatusText = styled.div`
  color: #767676;
`;

export const AccountStatusWrapper  = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1em;
  font-size: 14px;
`;

export const StatusInfoWrapper  = styled.div`
  display: flex;
  align-items: center;

  .ant-popover {
    width: 300px;
  }

  .ant-popover-message > .anticon {
    color: #FFC53D;
  }

  .ant-popover-buttons {
      .ant-btn {
        width: 70px;
        height: 30px;
      }

      .ant-btn-primary {
        background: #00918E;
        border-radius: 4px;
        border-color: #00918E;
      }
  }
`;

export const ErrorMessage = styled.span`
  color: ${theme.colors.utilities.error};
`;

export const StatusInfoText  = styled.div``;
